import React, { useEffect, useState } from 'react';
import useProps from '../_util/useProps';
import classname from 'classnames';
import { getImage } from '../renderer';
import { isArray, isObject, isString, chunk } from 'lodash';

export const getIcon = v => {
    const { icon, text, ...other } = isString(v) ? { icon: v } : v;

    return getImage({ color: '#007FF9', icon, hideFooter: true, ...other });
};

const getStyleByObject = _style => {
    let { type, style } = _style;

    if (type) {
        if (type === 'Marker') {
            return getIcon(style);
        } else if (type === 'Polyline') {
            return getIcon({ icon: 'GD_CSK', ..._style });
        } else if (type === 'Polygon') {
            return getIcon({ icon: 'AREA', ..._style });
        } else {
            return getIcon(_style);
        }
    } else if (_style.icon) {
        return getImage({ hideFooter: true, ..._style });
    } else if (_style.image) {
        return _style.image;
    } else {
        return getImage(_style);
    }
};

const getStyle = v => {
    if (v) {
        if (isString(v)) {
            return getIcon(v);
        } else if (isObject(v)) {
            return getStyleByObject(v);
        }
    }
};

const getItem = v => {
    let imgList = [];
    if (v.legend) {
        if (isArray(v.legend)) {
            v.legend.map(l => {
                let icon = getStyle(l);
                icon && imgList.push({ name: l.name, src: icon });
            });
        } else {
            let icon = getStyle(v.legend);
            icon && imgList.push({ name: v.name, src: icon });
        }
    } else if (v.style) {
        if (isString(v.style)) {
            let icon = getStyle(v.style);
            icon && imgList.push({ name: v.name, src: icon });
        } else if (isObject(v.style)) {
            let icon = getStyleByObject(v.style);
            icon && imgList.push({ name: v.name, src: icon });
        } else if (isArray(v.style)) {
            v.style.map(l => {
                let icon = getStyleByObject(l);
                icon && imgList.push({ name: l.name, src: icon });
            });
        }
    }

    return imgList;
};

const getTreeData = data => {
    let imgList = [];
    data.map(v => {
        if (v.group?.length) {
            v.group.map(r => {
                if (!r.hasOwnProperty('show') || r.show) {
                    imgList.push(...getItem(r));
                }
            });
        } else {
            imgList.push(...getItem(v));
        }
    });

    return imgList;
};

const Content = props => {
    const { data = [], column, columLength, children } = props;

    let _data = [];
    if (data?.length) {
        if (column) {
            _data = chunk(data, Math.ceil(data.length / column));
        } else if (data?.length >= 10) {
            if (columLength) {
                _data = chunk(data, columLength);
            } else {
                // 通过十分位 + 1 得到数组需要分割的数量例如：10 => 2、 20 => 3、 30 => 4
                let num = Number(String(data.length)[0]) + 1;
                _data = chunk(data, Math.ceil(data.length / num));
            }
        } else {
            _data = [data];
        }
    }

    return (
        <div className={classname('cs-tools-legend-list-wrap')}>
            {_data?.length > 0 && (
                <div
                    className={classname('cs-tools-legend-list-column')}
                    style={
                        _data?.length >= 2
                            ? {}
                            : {
                                  maxWidth: 270,
                                  maxHeight: 270,
                                  overflowY: 'auto',
                              }
                    }
                >
                    {_data.map((list, index) => (
                        <div key={`${index}`} className={classname('cs-tools-legend-list')}>
                            {list.map((v, i) => (
                                <div
                                    key={`${index}_${i}`}
                                    className={classname('cs-tools-legend-item')}
                                >
                                    <img
                                        src={v.src}
                                        alt=""
                                        className={classname('cs-tools-legend-item-img')}
                                    />
                                    <div className={classname('cs-tools-legend-item-title')}>
                                        {v.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}

            {children}
        </div>
    );
};
export default function(props) {
    const { className, extra, style, column, columLength, children, content } = props;
    const { map } = useProps();
    const [treeData, setTreeData] = useState([]);

    useEffect(() => {
        const layersChange = () => {
            let layers = map.getVisibleLayersByKeys();

            setTreeData(getTreeData(layers));
        };

        layersChange();
        map.layers.on('change', layersChange);

        return () => {
            map.layers.un('change', layersChange);
        };
    }, []);

    return (
        <div className={classname('cs-tools-legend', className)} style={style}>
            <div className={classname('cs-tools-legend-content')}>
                <div className={classname('cs-tools-legend-title')}>图例</div>
                {extra}
            </div>

            <Content data={treeData} column={column} columLength={columLength}>
                {content}
            </Content>

            {children}
        </div>
    );
}
